<template>
  <div class="md-layout">
    <div class="md-layout-item">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon">
            <md-icon>assignment</md-icon>
          </div>
          <h4 class="title">Programs</h4>
          <div class="md-card-header-icon md-card-header-green text-right">
            <md-button
              v-if="$store.role === 1 || $store.role === 4"
              @click="goToCreate"
              class="md-success"
              >CREATE PROGRAM</md-button
            >
          </div>
        </md-card-header>
        <md-card-content>
          <md-table
            :value="queriedData"
            :md-sort.sync="currentSort"
            :md-sort-order.sync="currentSortOrder"
            :md-sort-fn="customSort"
            class="paginated-table table-striped table-hover"
          >
            <md-table-toolbar>
              <md-field>
                <label for="pages">Per page</label>
                <md-select
                  v-model="pagination.perPage"
                  name="pages"
                  @md-selected="customSort"
                >
                  <md-option
                    v-for="item in pagination.perPageOptions"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                    {{ item }}
                  </md-option>
                </md-select>
              </md-field>
              <div>
                <md-button
                  v-if="$store.user_id === 1 || $store.user_id === 136"
                  style="margin-left: 10px"
                  @click="updateAllPanel"
                  class="md-warning"
                >
                  Update list
                </md-button>
                <md-button
                  style="margin-left: 10px"
                  @click="filterPanel"
                  class="md-info"
                >
                  Filters
                </md-button>
                <md-button
                  style="margin-left: 10px"
                  @click="clearFilters"
                  class="md-primary md-just-icon md-round"
                >
                  <md-icon>delete_sweep</md-icon>
                  <md-tooltip md-direction="bottom">Clear Filters</md-tooltip>
                </md-button>
                <md-button
                  style="margin-left: 10px"
                  @click="downloadPrograms"
                  class="md-info md-just-icon md-round"
                >
                  <md-icon>cloud_download</md-icon>
                  <md-tooltip md-direction="bottom">Download</md-tooltip>
                </md-button>
              </div>
            </md-table-toolbar>

            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell md-label="Name" md-sort-by="name">{{
                item.name
              }}</md-table-cell>
              <md-table-cell md-label="University" md-sort-by="university">{{
                item.university.name
              }}</md-table-cell>
              <md-table-cell md-label="Degree" md-sort-by="type">{{
                item.type
              }}</md-table-cell>
              <md-table-cell
                md-label="Language"
                md-sort-by="education_language"
                >{{ item.education_language }}</md-table-cell
              >
              <md-table-cell md-label="Tuition fee" md-sort-by="price"
                >{{ item.price }} {{ item.currency }}</md-table-cell
              >
              <md-table-cell
                md-label="Disc. Fee"
                v-if="item.discounted_price"
                md-sort-by="discounted_price"
                >{{ item.discounted_price }} {{ item.currency }}</md-table-cell
              >
              <md-table-cell
                md-label="Disc. Fee"
                v-else
                md-sort-by="discounted_price"
                >-</md-table-cell
              >
              <md-table-cell
                md-label="Comm. Rate"
                v-if="$store.role === 3 && item.agency_commission"
                >% {{ item.agency_commission }}</md-table-cell
              >
              <md-table-cell md-label="Comm. Rate" v-else-if="$store.role === 3"
                >-</md-table-cell
              >
              <md-table-cell
                md-label="Commission"
                v-if="$store.role === 3 && item.agency_commission_price"
                >{{ item.agency_commission_price }}
                {{ item.currency }}</md-table-cell
              >
              <md-table-cell
                md-label="Commission."
                v-else-if="$store.role === 3"
                >-</md-table-cell
              >
              <md-table-cell
                md-label="Fix Comm."
                v-if="item.fix_commission_price"
                >{{ item.fix_commission_price }} USD</md-table-cell
              >
              <md-table-cell md-label="Fix Comm." v-else>-</md-table-cell>
              <md-table-cell
                md-label="Stu. Fix Comm."
                v-if="$store.role === 1 && item.student_fix_commission_price"
                >{{ item.student_fix_commission_price }} USD</md-table-cell
              >
              <md-table-cell
                md-label="Stu. Fix Comm."
                v-else-if="$store.role === 1"
                >-</md-table-cell
              >
              <md-table-cell md-label="Scope" md-sort-by="scope">{{
                item.scope
              }}</md-table-cell>
              <md-table-cell md-label="Quota" md-sort-by="quota" v-if="item.is_quota_full">Full</md-table-cell>
              <md-table-cell md-label="Quota" md-sort-by="quota" v-else >Available</md-table-cell>
              <md-table-cell
                md-label="Education Type"
                md-sort-by="education_type"
                >{{ item.education_type }}</md-table-cell
              >
              <md-table-cell v-if="item.current_deadline" md-label="Deadline">{{
                item.current_deadline
              }}</md-table-cell>
              <md-table-cell v-else md-label="Deadline" md-sort-by="deadline"
                >-</md-table-cell
              >
              <md-table-cell md-label="Status">{{ item.status }}</md-table-cell>
              <md-table-cell md-label="Actions">
                <md-button
                  style="margin-right: 14px;"
                  class="md-just-icon md-info md-round"
                  @click.native="handleView(item)"
                >
                  <md-icon>info</md-icon>
                  <md-tooltip md-direction="bottom">View</md-tooltip>
                </md-button>
                <md-button
                  style="margin-right: 14px;"
                  class="md-just-icon md-warning md-round"
                  @click.native="handleEdit(item)"
                  v-if="$store.role === 1 || $store.role === 4"
                >
                  <md-icon>create</md-icon>
                  <md-tooltip md-direction="bottom">Edit</md-tooltip>
                </md-button>
              </md-table-cell>
            </md-table-row>
          </md-table>
        </md-card-content>
        <md-card-content class="md-size-50 mx-auto" v-if="table_spinner">
          <md-progress-spinner md-mode="indeterminate"></md-progress-spinner>
        </md-card-content>
        <md-card-actions md-alignment="space-between">
          <div class="">
            <p class="card-category">
              Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
            </p>
          </div>
          <pagination
            class="pagination-no-border pagination-success"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="total"
            @page="updatePage"
          >
          </pagination>
        </md-card-actions>
      </md-card>
      <md-dialog :md-active.sync="showFilters" class="filterPanelClass">
        <md-dialog-title>Filters</md-dialog-title>
        <div class="md-layout-item md-size-100 md-small-size-100">
          <md-field>
            <md-icon>add_location</md-icon>
            <label>Country</label>
            <md-select
              v-model="country"
              name="country_of_residence"
              @md-selected="onChangeCountry"
            >
              <md-option value="">Select Country</md-option>
              <md-option v-for="c in countries" v-bind:key="c.id" :value="c.id"
                >{{ c.name }}
              </md-option>
            </md-select>
          </md-field>
        </div>
        <div class="md-layout-item md-size-100 md-small-size-100">
          <md-field>
            <md-icon>add_location</md-icon>
            <label>City</label>
            <md-select
              v-model="city"
              name="city"
              @md-selected="onChangeCity"
            >
              <md-option value="">Select City</md-option>
              <md-option v-for="c in cities" v-bind:key="c.id" :value="c.id"
                >{{ c.name }}
              </md-option>
            </md-select>
          </md-field>
        </div>
        <div class="md-layout-item md-size-100 md-small-size-100">
          <md-field>
            <md-icon>add_location</md-icon>
            <label>University</label>
            <md-select v-model="university" name="university" multiple>
              <md-option value="">Select University</md-option>
              <md-option
                v-for="c in universities"
                v-bind:key="c.id"
                :value="c.id"
                >{{ c.name }}</md-option
              >
            </md-select>
          </md-field>
        </div>
        <div class="md-layout-item md-size-100 md-small-size-100">
          <md-field>
            <md-icon>account_balance</md-icon>
            <label>Program Name</label>
            <md-input v-model="name" type="text"></md-input>
          </md-field>
        </div>
        <div class="md-layout-item md-size-100 md-small-size-100">
          <md-field>
            <md-icon>add_location</md-icon>
            <label>Degree</label>
            <md-select v-model="type" name="type" multiple>
              <md-option value="">Select Type</md-option>
              <md-option value="1">Associate degree</md-option>
              <md-option value="2">Bachelor degree</md-option>
              <md-option value="3">Master Non-Thesis</md-option>
              <md-option value="4">Master With Thesis</md-option>
              <md-option value="5">Phd degree</md-option>
            </md-select>
          </md-field>
        </div>
        <div class="md-layout-item md-size-100 md-small-size-100">
          <md-field>
            <md-icon>add_location</md-icon>
            <label>Education Duration</label>
            <md-select
              v-model="education_duration"
              name="education_duration"
              multiple
            >
              <md-option value="">Select Education Duration</md-option>
              <md-option value="0">1 year</md-option>
              <md-option value="1">1.5 year</md-option>
              <md-option value="2">2 year</md-option>
              <md-option value="3">3 year</md-option>
              <md-option value="4">4 year</md-option>
              <md-option value="5">5 year</md-option>
              <md-option value="6">6 year</md-option>
              <md-option value="7">6+ year</md-option>
            </md-select>
          </md-field>
        </div>
        <div class="md-layout-item md-size-100 md-small-size-100">
          <md-field>
            <md-icon>add_location</md-icon>
            <label>Education Type</label>
            <md-select v-model="education_type" name="education_type" multiple>
              <md-option value="">Select Education Type</md-option>
              <md-option value="1">Full time</md-option>
              <md-option value="2">Evening Period</md-option>
              <md-option value="3">Online</md-option>
            </md-select>
          </md-field>
        </div>

        <div class="md-layout-item md-size-100 md-small-size-100">
          <md-field>
            <md-icon>add_location</md-icon>
            <label>Campus Type</label>
            <md-select v-model="campus_type" name="campus_type">
              <md-option value="">Select Campus Type</md-option>
              <md-option value="1">On campus</md-option>
              <md-option value="2">Off campus</md-option>
            </md-select>
          </md-field>
        </div>

        <div class="md-layout-item md-size-100 md-small-size-100">
          <md-field>
            <md-icon>add_location</md-icon>
            <label>University Type</label>
            <md-select v-model="university_type" name="university_type">
              <md-option value="">Select University Type</md-option>
              <md-option value="2">Private</md-option>
              <md-option value="1">State</md-option>
            </md-select>
          </md-field>
        </div>

        <div class="md-layout-item md-size-100 md-small-size-100">
          <md-field>
            <md-icon>leaderboard</md-icon>
            <label>Education Language</label>
            <md-select
              v-model="education_language"
              name="education_language"
              multiple
            >
              <md-option value="">Select Language</md-option>
              <md-option value="1">Turkish</md-option>
              <md-option value="2">English</md-option>
              <md-option value="5">Arabic</md-option>
              <md-option value="6">Russian</md-option>
              <md-option value="7">Spanish</md-option>
              <md-option value="8">French</md-option>
              <md-option value="9">German</md-option>
              <md-option value="3">%30 English %70 Turkish </md-option>
              <md-option value="4">%50 English %50 Turkish </md-option>
              <md-option value="10">%30 Arabic %70 Turkish </md-option>
              <md-option value="11">%30 German %70 Turkish </md-option>
            </md-select>
          </md-field>
        </div>

        <md-dialog-actions>
          <md-button class="md-danger" @click="showFilters = false"
            >Close</md-button
          >
          <md-button class="md-success" @click="addFilter">Filter</md-button>
        </md-dialog-actions>
      </md-dialog>

      <md-dialog :md-active.sync="showUpdateAllPanel" class="filterPanelClass">
        <div class="md-layout viewPanel" style="overflow: auto;">
          <div class="md-layout-item md-size-33 md-small-size-100">
            <div class="md-layout-item md-size-100 md-small-size-100">
              <md-dialog-title>Dates</md-dialog-title>
            </div>
            <md-datepicker
              v-model="p_application_autumn_start_date"
              md-immediately
            >
              <label>Application Fall Start Date</label>
            </md-datepicker>

            <md-datepicker
              v-model="p_application_autumn_end_date"
              md-immediately
            >
              <label>Application Fall End Date</label>
            </md-datepicker>

            <md-datepicker
              v-model="p_application_spring_start_date"
              md-immediately
            >
              <label>Application Spring Start Date</label>
            </md-datepicker>

            <md-datepicker
              v-model="p_application_spring_end_date"
              md-immediately
            >
              <label>Application Spring End Date</label>
            </md-datepicker>

            <md-datepicker v-model="p_lesson_start_date" md-immediately>
              <label>Lesson Start Date</label>
            </md-datepicker>

            <div class="md-layout-item md-size-100 md-small-size-100">
              <md-dialog-title>Prices</md-dialog-title>
            </div>
            <md-field>
              <md-icon>attach_money</md-icon>
              <label>Price</label>
              <md-input v-model="p_price" type="text"> </md-input>
            </md-field>
            <md-field>
              <md-icon>attach_money</md-icon>
              <label>Discounted Price</label>
              <md-input v-model="p_discounted_price" type="text"> </md-input>
            </md-field>
            <md-field>
              <md-icon>attach_money</md-icon>
              <label>Turkish Preparation Price</label>
              <md-input v-model="turkish_preparation" type="text"> </md-input>
            </md-field>
            <md-field>
              <md-icon>attach_money</md-icon>
              <label>English Preparation Price</label>
              <md-input v-model="english_preparation" type="text"> </md-input>
            </md-field>
            <md-field>
              <md-icon>%</md-icon>
              <label>Cash Payment Discount</label>
              <md-input v-model="cash_payment_discount" type="text"> </md-input>
            </md-field>
            <md-field>
              <md-icon>%</md-icon>
              <label>Sibling Discount</label>
              <md-input v-model="sibling_discount" type="text"> </md-input>
            </md-field>
            <md-field>
              <md-icon>%</md-icon>
              <label>Commission</label>
              <md-input v-model="p_commission" type="text"> </md-input>
            </md-field>
            <md-field>
              <md-icon>attach_money</md-icon>
              <label>Fix Commission Price</label>
              <md-input v-model="p_fix_commission_price" type="text">
              </md-input>
            </md-field>
            <md-field>
              <md-icon>attach_money</md-icon>
              <label>Student Fix Commission Price</label>
              <md-input v-model="p_student_fix_commission_price" type="text">
              </md-input>
            </md-field>
            <md-field>
              <md-icon>attach_money</md-icon>
              <label>Currency</label>
              <md-select v-model="p_currency" name="p_currency">
                <md-option value="">Select Scope</md-option>
                <md-option value="TRY">Turkish Lira</md-option>
                <md-option value="USD">US Dollar</md-option>
                <md-option value="EUR">Euro</md-option>
              </md-select>
            </md-field>
          </div>

          <div class="md-layout-item md-size-33 md-small-size-100">
            <div class="md-layout-item md-size-100 md-small-size-100">
              <md-dialog-title>Types</md-dialog-title>
            </div>
            <md-field>
              <md-icon>add_location</md-icon>
              <label>Degree</label>
              <md-select v-model="p_type" name="p_type">
                <md-option value="">Select Type</md-option>
                <md-option value="1">Associate degree</md-option>
                <md-option value="2">Bachelor degree</md-option>
                <md-option value="3">Master Non-Thesis</md-option>
                <md-option value="4">Master With Thesis</md-option>
                <md-option value="5">Phd degree</md-option>
              </md-select>
            </md-field>

            <md-field>
              <md-icon>add_location</md-icon>
              <label>Scope</label>
              <md-select v-model="p_scope" name="scope">
                <md-option value="">Select Scope</md-option>
                <md-option value="1">Term</md-option>
                <md-option value="2">Yearly</md-option>
                <md-option value="3">Full Tuition</md-option>
              </md-select>
            </md-field>

            <md-field>
              <md-icon>add_location</md-icon>
              <label>Education Duration</label>
              <md-select
                v-model="p_education_duration"
                name="p_education_duration"
              >
                <md-option value="">Select Education Duration</md-option>
                <md-option value="0">1 year</md-option>
                <md-option value="1">1.5 year</md-option>
                <md-option value="2">2 year</md-option>
                <md-option value="3">3 year</md-option>
                <md-option value="4">4 year</md-option>
                <md-option value="5">5 year</md-option>
                <md-option value="6">6 year</md-option>
                <md-option value="7">6+ year</md-option>
              </md-select>
            </md-field>

            <md-field>
              <md-icon>add_location</md-icon>
              <label>Education Type</label>
              <md-select v-model="p_education_type" name="p_education_type">
                <md-option value="">Select Education Type</md-option>
                <md-option value="1">Full time</md-option>
                <md-option value="2">Evening Period</md-option>
                <md-option value="3">Online</md-option>
              </md-select>
            </md-field>

            <md-field>
              <md-icon>add_location</md-icon>
              <label>Campus Type</label>
              <md-select v-model="p_campus_type" name="p_campus_type">
                <md-option value="">Select Campus Type</md-option>
                <md-option value="1">On campus</md-option>
                <md-option value="2">Off campus</md-option>
              </md-select>
            </md-field>

            <md-field>
              <md-icon>leaderboard</md-icon>
              <label>Education Language</label>
              <md-select
                v-model="p_education_language"
                name="p_education_language"
              >
                <md-option value="">Select Language</md-option>
                <md-option value="1">Turkish</md-option>
                <md-option value="2">English</md-option>
                <md-option value="5">Arabic</md-option>
                <md-option value="6">Russian</md-option>
                <md-option value="7">Spanish</md-option>
                <md-option value="8">French</md-option>
                <md-option value="9">German</md-option>
                <md-option value="3">%30 English %70 Turkish </md-option>
                <md-option value="4">%50 English %50 Turkish </md-option>
                <md-option value="10">%30 Arabic %70 Turkish </md-option>
                <md-option value="11">%30 German %70 Turkish </md-option>
              </md-select>
            </md-field>
            <md-field>
              <md-icon>leaderboard</md-icon>
              <label>Quota</label>
              <md-input v-model="p_quota" type="text"> </md-input>
            </md-field>
          </div>

          <div class="md-layout-item md-size-33 md-small-size-100">
            <div class="md-layout-item md-size-100 md-small-size-100">
              <md-dialog-title>Detail</md-dialog-title>
            </div>
            <md-field>
              <md-icon>leaderboard</md-icon>
              <label>Address</label>
              <md-input v-model="p_address" type="text"> </md-input>
            </md-field>

            <md-field>
              <md-icon>leaderboard</md-icon>
              <label>Website</label>
              <md-input v-model="p_website" type="text"> </md-input>
            </md-field>

            <md-field>
              <md-icon>leaderboard</md-icon>
              <label>Detail</label>
              <md-input v-model="p_detail" type="text"> </md-input>
            </md-field>

            <md-field>
              <md-icon>leaderboard</md-icon>
              <label>Modules</label>
              <md-input v-model="p_modules" type="text"> </md-input>
            </md-field>

            <md-field>
              <md-icon>leaderboard</md-icon>
              <label>Admission and fees</label>
              <md-input v-model="p_admission_and_fees" type="text"> </md-input>
            </md-field>

            <md-field>
              <md-icon>leaderboard</md-icon>
              <label>Admission Requirements</label>
              <md-input v-model="p_requirements" type="text"> </md-input>
            </md-field>

            <md-field>
              <md-icon>leaderboard</md-icon>
              <label>Installments</label>
              <md-input v-model="p_installments" type="text"> </md-input>
            </md-field>

            <md-field>
              <md-icon>leaderboard</md-icon>
              <label>Deposit</label>
              <md-input v-model="p_deposit" type="text"> </md-input>
            </md-field>

            <md-field>
              <md-icon>leaderboard</md-icon>
              <label>Notes</label>
              <md-input v-model="p_notes" type="text"> </md-input>
            </md-field>

            <md-field>
              <md-icon>add_location</md-icon>
              <label>Is quota full?</label>
              <md-select v-model="p_is_quota_full" name="p_is_quota_full">
                <md-option value="">Select</md-option>
                <md-option value="true">True</md-option>
                <md-option value="false">False</md-option>
              </md-select>
            </md-field>

            <md-field>
              <md-icon>add_location</md-icon>
              <label>Refund Policy</label>
              <md-select v-model="p_refund_policy" name="p_refund_policy">
                <md-option value="1">No Refund</md-option>
                <md-option value="2">%25 Refund</md-option>
                <md-option value="3">%50 Refund</md-option>
                <md-option value="4">%75 Refund</md-option>
                <md-option value="5">Full Refund</md-option>
              </md-select>
            </md-field>

            <md-field>
              <md-icon>rule</md-icon>
              <label>Status</label>
              <md-select v-model="p_status" name="status">
                <md-option value="">Select Status</md-option>
                <md-option value="1">Full Active</md-option>
                <md-option value="2">Active</md-option>
                <md-option value="3">Inactive</md-option>
              </md-select>
            </md-field>
          </div>

          <div class="md-layout-item md-size-100 md-small-size-100">
            <md-dialog-actions>
              <md-button class="md-danger" @click="showUpdateAllPanel = false"
                >Close</md-button
              >
              <md-button class="md-success" @click="updateAll"
                >Update</md-button
              >
            </md-dialog-actions>
          </div>
        </div>
      </md-dialog>

      <md-dialog :md-active.sync="showViews">
        <div class="md-layout viewPanel" style="overflow: auto;">
          <div class="md-layout-item md-size-33 md-small-size-100">
            <md-dialog-title>University</md-dialog-title>
            <h5 class="card-title"><b>Name :</b> {{ selectedProgram.university.name }}</h5>
            <h5 class="card-title"><b>Type :</b> {{ selectedProgram.university.type }}</h5>
            <h5 class="card-title"><b>Country :</b> {{ selectedProgram.uni_country }}</h5>
            <h5 class="card-title"><b>City :</b> {{ selectedProgram.uni_city }}</h5>
            <h5 class="card-title"><b>Address :</b> {{ selectedProgram.address }}</h5>
          </div>
          <div class="md-layout-item md-size-33 md-small-size-100">
            <md-dialog-title>Program</md-dialog-title>
            <h5 class="card-title"><b>Program name :</b> {{ selectedProgram.name }}</h5>
            <h5 class="card-title"><b>Degree :</b> {{ selectedProgram.type }}</h5>
            <h5 class="card-title"><b>Duration :</b> {{ selectedProgram.education_duration }}</h5>
            <h5 class="card-title"><b>Language :</b> {{ selectedProgram.education_language }}</h5>
            <h5 class="card-title">
              <b>Education type :</b> {{ selectedProgram.education_type }}
            </h5>
            <h5 class="card-title">
              <b>Campus type :</b> {{ selectedProgram.campus_type }}
            </h5>
            <h5 class="card-title"><b>Quota :</b> {{ selectedProgram.quota }}</h5>
            <h5 class="card-title">
              <b>Application Fall Start Date :</b>
              {{ selectedProgram.application_autumn_start_date }}
            </h5>
            <h5 class="card-title">
              <b>Application Fall End Date :</b>
              {{ selectedProgram.application_autumn_end_date }}
            </h5>
            <h5 class="card-title">
              <b>Application Spring Start Date :</b>
              {{ selectedProgram.application_spring_start_date }}
            </h5>
            <h5 class="card-title">
              <b>Application Spring End Date :</b>
              {{ selectedProgram.application_spring_end_date }}
            </h5>
            <h5 class="card-title">
              <b>Application Current Deadline :</b> {{ selectedProgram.current_deadline }}
            </h5>
            <h5 class="card-title">
              <b>Course start :</b> {{ selectedProgram.lesson_start_date }}
            </h5>
          </div>
          <div class="md-layout-item md-size-33 md-small-size-100">
            <md-dialog-title>Feeds</md-dialog-title>
            <h5 class="card-title">
              <b>Tuition fee :</b> {{ selectedProgram.price }} {{ selectedProgram.currency }}
            </h5>
            <h5 class="card-title">
              <b>Discounted fee :</b> {{ selectedProgram.program_discounted_fee }}
            </h5>
            <h5 class="card-title" v-if="selectedProgram.agency_commission"><b>Agency Commission :</b> % {{ selectedProgram.agency_commission }}</h5>
            <h5 class="card-title" v-if="selectedProgram.agency_commission_price"><b>Agency Commission Price :</b> {{ selectedProgram.agency_commission_price }} {{ selectedProgram.currency }}</h5>
            <h5 class="card-title" v-if="selectedProgram.fix_commission_price"><b>Agency Fix Commission Price :</b> {{ selectedProgram.fix_commission_price }} {{ selectedProgram.currency }}</h5>
            <h5 class="card-title" v-if="selectedProgram.extras.turkish_preparation"><b>Turkish Preparation Price :</b> {{ selectedProgram.extras.turkish_preparation }} {{ selectedProgram.currency }}</h5>
            <h5 class="card-title" v-if="selectedProgram.extras.english_preparation"><b>English Preparation Price :</b> {{ selectedProgram.extras.english_preparation }} {{ selectedProgram.currency }}</h5>
            <h5 class="card-title" v-if="selectedProgram.extras.german_preparation"><b>German Preparation Price :</b> {{ selectedProgram.extras.german_preparation }} {{ selectedProgram.currency }}</h5>
            <h5 class="card-title" v-if="selectedProgram.extras.arabic_preparation"><b>Arabic Preparation Price :</b> {{ selectedProgram.extras.arabic_preparation }} {{ selectedProgram.currency }}</h5>
            <h5 class="card-title" v-if="selectedProgram.extras.russian_preparation"><b>Russian Preparation Price :</b> {{ selectedProgram.extras.russian_preparation }} {{ selectedProgram.currency }}</h5>
            <h5 class="card-title" v-if="selectedProgram.extras.spanish_preparation"><b>Spanish Preparation Price :</b> {{ selectedProgram.extras.spanish_preparation }} {{ selectedProgram.currency }}</h5>
            <h5 class="card-title" v-if="selectedProgram.extras.chinese_preparation"><b>Chinese Preparation Price :</b> {{ selectedProgram.extras.chinese_preparation }} {{ selectedProgram.currency }}</h5>
            <h5 class="card-title" v-if="selectedProgram.extras.cash_payment_discount"><b>Cash Payment Discount :</b> % {{ selectedProgram.extras.cash_payment_discount }}</h5>
            <h5 class="card-title" v-if="selectedProgram.extras.sibling_discount"><b>Sibling Discount :</b> % {{ selectedProgram.extras.sibling_discount }}</h5>
            <h5 class="card-title"><b>Scope :</b> {{ selectedProgram.scope }}</h5>
            <h5 class="card-title">
              <b>Installments :</b> {{ selectedProgram.installments }}
            </h5>
            <h5 class="card-title"><b>Deposit :</b> {{ selectedProgram.deposit }}</h5>
            <h5 class="card-title">
              <b>Refundable :</b> {{ selectedProgram.program_refund_policy }}
            </h5>
          </div>
          <div class="md-layout-item md-size-100 md-small-size-100">
            <md-dialog-title>Program Notes</md-dialog-title>
            <h5
              class="card-title"
              v-for="p in selectedProgram.program_notes"
              v-bind:key="p.id"
              :value="p.id"
            >
              <b>-</b> {{ p }}
            </h5>
          </div>
        </div>
      </md-dialog>
    </div>
  </div>
</template>

<script>
import { Pagination } from "@/components";
import { jsPDF } from "jspdf";
import "jspdf-autotable";

export default {
  components: {
    Pagination
  },
  computed: {
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData() {
      return this.tableData;
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.pagination.total;
    },
    getParams() {
      return {
        ordering: this.getSortingKey(),
        limit: this.pagination.perPage,
        offset: this.from,
        ...this.searchQuery
      };
    }
  },
  data() {
    return {
      currentSort: "name",
      currentSortOrder: "asc",
      pagination: {
        perPage: 10,
        currentPage: 1,
        perPageOptions: [10, 20, 30],
        total: 0
      },
      searchQuery: {},
      propsToSearch: ["name", "type", "contract", "price", "discounted_price"],
      tableData: [],
      searchedData: [],
      first: true,

      table_spinner: true,
      showFilters: false,
      showUpdateAllPanel: false,
      showViews: false,

      universities: null,
      countries: null,
      cities: null,

      country: null,
      city: null,
      university: [],
      name: null,
      type: [],
      university_type: null,
      education_duration: [],
      education_language: [],
      education_type: [],
      campus_type: null,
      // for views
      selectedProgram: {university: {}, city: {country: {}}, extras: {}},
      // for update
      p_application_autumn_start_date: null,
      p_application_autumn_end_date: null,
      p_application_spring_start_date: null,
      p_application_spring_end_date: null,
      p_lesson_start_date: null,
      p_type: null,
      p_scope: null,
      p_education_duration: null,
      p_education_language: null,
      p_education_type: null,
      p_campus_type: null,
      p_quota: null,
      p_price: null,
      p_discounted_price: null,
      p_prep_price: null,
      p_prep_price_2: null,
      p_commission: null,
      p_fix_commission_price: null,
      p_student_fix_commission_price: null,
      p_currency: null,
      p_address: null,
      p_website: null,
      p_status: null,
      p_detail: null,
      p_modules: null,
      p_admission_and_fees: null,
      p_requirements: null,
      p_installments: null,
      p_deposit: null,
      p_refund_policy: null,
      p_is_quota_full: null,
      p_notes: null,
      // extras
      english_preparation: null,
      turkish_preparation: null,
      german_preparation: null,
      arabic_preparation: null,
      french_preparation: null,
      russian_preparation: null,
      spanish_preparation: null,
      chinese_preparation: null,
      cash_payment_discount: null,
      sibling_discount: null,
      extra_fields: [
          "english_preparation",
          "turkish_preparation",
          "german_preparation",
          "arabic_preparation",
          "french_preparation",
          "russian_preparation",
          "spanish_preparation",
          "chinese_preparation",
          "cash_payment_discount",
          "sibling_discount"
      ]
    };
  },
  methods: {
    goToCreate: function() {
      this.$router.push({ name: "Program Create" });
    },
    downloadPrograms: function() {
      const doc = new jsPDF();
      doc.autoTable({ html: "#my-table" });
      const body = [];
      for (const program in this.tableData) {
        body.push([
          this.tableData[program].name,
          this.tableData[program].university.name,
          this.tableData[program].type,
          this.tableData[program].education_language,
          this.tableData[program].price,
          this.tableData[program].discounted_price,
          this.tableData[program].scope,
          this.tableData[program].education_type,
          this.tableData[program].education_duration,
          this.tableData[program].current_deadline
        ]);
        if (program > 10) {
          break;
        }
      }

      // Or use javascript directly:
      doc.autoTable({
        styles: { fontSize: 8 },
        head: [
          [
            "Name",
            "University",
            "Degree",
            "Language",
            "Tuition Fee",
            "Disc. Fee",
            "Scope",
            "Education Type",
            "Duration",
            "Deadline"
          ]
        ],
        body: body
      });

      doc.save("programs.pdf");
    },
    getNotes: function(item) {
      if (item.notes) {
        return item.notes.split(";");
      }
      return [];
    },
    onChangeCountry: function(value) {
      if (value) {
        this.getCities(value)
      }
    },
    onChangeCity: function(value) {
      if (value) {
        this.getUniversities(value)
      }
    },
    getUniversities: function(city_id) {
      if (this.universities && !city_id) {
        return;
      }
      var params = {}
      if (city_id) {
        params.city = city_id
      }
      this.$store
        .getUniversities(params, true)
        .then(response => {
          this.universities = response.data.results;
        })
        .catch(error => {
          this.$notify({
            message: error.message,
            icon: "add_alert",
            type: "warning",
            verticalAlign: "top"
          });
        });
    },
    getCountries: function() {
      if (this.countries) {
        return;
      }
      this.$store
        .getCountries({"has_program": true}, true)
        .then(response => {
          this.countries = response.data.results;
        })
        .catch(error => {
          this.$notify({
            message: error.message,
            icon: "add_alert",
            type: "warning",
            verticalAlign: "top"
          });
        });
    },
    getCities: function(country_id) {
      if (this.cities && !country_id) {
        return;
      }
      var params = {has_program: true}
      if (country_id) {
        params.country = country_id
      }
      this.$store
        .getCities(params, true)
        .then(response => {
          this.cities = response.data.results;
        })
        .catch(error => {
          this.$notify({
            message: error.message,
            icon: "add_alert",
            type: "warning",
            verticalAlign: "top"
          });
        });
    },
    filterPanel: function() {
      this.showFilters = true;
      this.getUniversities()
      this.getCountries()
      this.getCities()
    },
    getExtrasField: function() {
      let extras = {}
      for (const field in this.extra_fields) {
        if (this[this.extra_fields[field]]) {
          extras[this.extra_fields[field]] = this[this.extra_fields[field]]
        }
      }
      return extras
    },
    updateAllPanel: function() {
      this.showUpdateAllPanel = true;
    },
    updateAll: function() {
      var params = this.getParams;
      let origin_data = {};
      let data = {
        application_autumn_start_date: this.p_application_autumn_start_date,
        application_autumn_end_date: this.p_application_autumn_end_date,
        application_spring_start_date: this.p_application_spring_start_date,
        application_spring_end_date: this.p_application_spring_end_date,
        lesson_start_date: this.p_lesson_start_date,
        type: this.p_type,
        scope: this.p_scope,
        education_duration: this.p_education_duration,
        education_language: this.p_education_language,
        education_type: this.p_education_type,
        campus_type: this.p_campus_type,
        quota: this.p_quota,
        price: this.p_price,
        discounted_price: this.p_discounted_price,
        prep_price: this.p_prep_price,
        prep_price_2: this.p_prep_price_2,
        commission: this.p_commission,
        fix_commission_price: this.p_fix_commission_price,
        student_fix_commission_price: this.p_student_fix_commission_price,
        currency: this.p_currency,
        address: this.p_address,
        website: this.p_website,
        status: this.p_status,
        detail: this.p_detail,
        modules: this.p_modules,
        admission_and_fees: this.p_admission_and_fees,
        requirements: this.p_requirements,
        installments: this.p_installments,
        deposit: this.p_deposit,
        refund_policy: this.p_refund_policy,
        is_quota_full: this.p_is_quota_full,
        notes: this.p_notes,
        extras: this.getExtrasField()
      };
      for (const field in data) {
        if (data[field]) {
          if (data[field] instanceof Date) {
            origin_data[field] = data[field]
              .toLocaleDateString("ko-KR")
              .replaceAll(". ", "-")
              .replaceAll(".", "");
          } else {
            origin_data[field] = data[field];
          }
        }
      }
      this.$store
        .updatePrograms(origin_data, params)
        .then(response => {
          this.$notify({
            message: "Program Updated.",
            icon: "add_alert",
            type: "success",
            verticalAlign: "top"
          });
          this.showUpdateAllPanel = false;

          this.p_application_autumn_start_date = null;
          this.p_application_autumn_end_date = null;
          this.p_application_spring_start_date = null;
          this.p_application_spring_end_date = null;
          this.p_lesson_start_date = null;
          this.p_type = null;
          this.p_scope = null;
          this.p_education_duration = null;
          this.p_education_language = null;
          this.p_education_type = null;
          this.p_campus_type = null;
          this.p_quota = null;
          this.p_price = null;
          this.p_discounted_price = null;
          this.p_prep_price = null;
          this.p_prep_price_2 = null;
          this.p_commission = null;
          this.p_fix_commission_price = null;
          this.p_student_fix_commission_price = null;
          this.p_currency = null;
          this.p_address = null;
          this.p_website = null;
          this.p_status = null;
          this.p_detail = null;
          this.p_modules = null;
          this.p_admission_and_fees = null;
          this.p_requirements = null;
          this.p_installments = null;
          this.p_deposit = null;
          this.p_refund_policy = null;
          this.p_is_quota_full = null;
          this.p_notes = null;
          this.getPrograms();
        })
        .catch(error => {
          this.showUpdateAllPanel = false;
          this.$notify({
            message: JSON.stringify(error.response.data),
            icon: "add_alert",
            type: "warning",
            verticalAlign: "top"
          });
        });
    },
    clearFilters: function() {
      this.searchQuery = {};
      this.country = null;
      this.city = null;
      this.university = [];
      this.name = null;
      this.type = [];
      this.education_duration = [];
      this.education_language = [];
      this.education_type = [];
      this.campus_type = null;
      this.pagination.currentPage = 1;
      this.getPrograms();
    },
    addFilter: function() {
      let origin_params = {};
      let params = {
        country: this.country,
        city: this.city,
        university: this.university.toString(),
        name: this.name,
        type: this.type.toString(),
        university_type: this.university_type,
        education_duration: this.education_duration.toString(),
        education_language: this.education_language.toString(),
        education_type: this.education_type.toString(),
        campus_type: this.campus_type
      };
      for (const field in params) {
        if (
          params[field] === null ||
          params[field] === undefined ||
          params[field] === ""
        ) {
          continue;
        }
        origin_params[field] = params[field];
      }
      this.searchQuery = origin_params;
      this.pagination.currentPage = 1;
      this.getPrograms();
      this.showFilters = false;
    },
    customSort(value) {
      if (this.first) {
        this.first = false;
        this.checkQueryParam();
      } else {
        this.pagination.currentPage = 1;
      }
      this.getPrograms();
    },
    getSortingKey() {
      var key = this.currentSort;
      if (this.currentSortOrder === "desc") {
        key = "-" + this.currentSort;
      }
      return key;
    },
    handleEdit(item) {
      this.$router.push({ name: "Program Update", params: { id: item.id } });
    },
    handleView(item) {
      this.selectedProgram = item
      if (item.city) {
        this.selectedProgram.uni_country = item.city.country.name;
        this.selectedProgram.uni_city = item.city.name;
      } else {
        this.selectedProgram.uni_country = "-";
        this.selectedProgram.uni_city = "-";
      }
      if (item.discounted_price) {
        this.selectedProgram.program_discounted_fee =
          item.discounted_price + " " + item.currency;
      } else {
        this.selectedProgram.program_discounted_fee = "-";
      }
      this.selectedProgram.program_refund_policy = this.$store.refund_policy[
        item.refund_policy
      ];
      this.selectedProgram.program_notes = this.getNotes(item);
      this.showViews = true;
    },
    getPrograms() {
      this.tableData = [];
      this.table_spinner = true;
      var params = this.getParams;
      this.$store
        .getPrograms(params)
        .then(response => {
          this.tableData = response.data.results;
          this.pagination.total = response.data.count;
          if (params.offset) {
            this.pagination.currentPage = this.getCurrentPage(params.offset);
          }
          this.table_spinner = false;
        })
        .catch(error => {
          this.table_spinner = false;
          this.$notify({
            message: JSON.stringify(error.response.data),
            icon: "add_alert",
            type: "warning",
            verticalAlign: "top"
          });
        });
    },
    updatePage(page) {
      this.getPrograms();
    },
    getCurrentPage(offset) {
      return offset / this.pagination.perPage + 1;
    },
    checkQueryParam() {
      if (window.location.search !== "") {
        var params = window.location.search
          .slice(1)
          .split("&")
          .map(p => p.split("="))
          .reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});
        if (params.ordering) {
          if (params.ordering[0] === "-") {
            this.currentSortOrder = "desc";
            params.ordering = params.ordering.replace("-", "");
          } else {
            this.currentSortOrder = "asc";
          }
          this.currentSort = params.ordering;
          delete params.ordering;
        }
        if (params.limit) {
          this.pagination.perPage = parseInt(params.limit);
          delete params.limit;
        }
        if (params.offset) {
          this.pagination.currentPage = this.getCurrentPage(params.offset);
          delete params.offset;
        }
        this.searchQuery = params;
      }
    }
  },
  watch: {
    searchQuery(query) {
      let params = this.getParams;
      let query_param = Object.keys(params)
        .map(key => key + "=" + params[key])
        .join("&");
      window.history.replaceState(
        "page",
        "Title",
        window.location.pathname + "?" + query_param
      );
    },
    pagination: {
      deep: true,
      handler(val) {
        let params = this.getParams;
        let query_param = Object.keys(params)
          .map(key => key + "=" + params[key])
          .join("&");
        window.history.replaceState(
          "page",
          "Title",
          window.location.pathname + "?" + query_param
        );
      }
    }
  }
};
</script>

<style lang="css" scoped>
.md-card .md-card-actions {
  border: 0;
  margin-left: 20px;
  margin-right: 20px;
}

.viewPanel {
  padding: 30px;
}
</style>
